import { trans } from "@/service/i18n/i18n";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { videoCardBadgeStyles } from "@/components/common/video-card/service";
import {
  getVideoLength,
  isBeforeWeekAgo,
} from "@/components/common/video-card/components/service";

export const PlaylistEpisodePreset = ({
  data,
  active,
}: {
  data: PlaylistEpisodePreviewVM;
  active: boolean;
}) => {
  const { duration, episodeNumber, publishedAt, currentTime } = data;
  return (
    <>
      <>
        <Badge
          className={cn(
            videoCardBadgeStyles,
            "right-3 bottom-3 bg-black text-white",
          )}
        >
          {getVideoLength(duration ?? 0)}
        </Badge>
        {episodeNumber == -1 ? (
          <>
            {publishedAt && !isBeforeWeekAgo(publishedAt) && (
              <Badge
                className={cn(
                  videoCardBadgeStyles,
                  "bg-remedium-blue top-3 left-3 text-white",
                )}
              >
                NOWOŚĆ
              </Badge>
            )}
          </>
        ) : (
          <Badge
            className={cn(
              videoCardBadgeStyles,
              "top-3 left-3 bg-black text-white",
            )}
          >
            Część {episodeNumber}
          </Badge>
        )}
      </>
      {currentTime != null && currentTime > 0 && (
        <div
          className={"absolute bottom-0 left-0 z-1 h-1 bg-red-500"}
          style={{
            width: `${(currentTime / (duration as number)) * 100}%`,
          }}
        ></div>
      )}
    </>
  );
};
